var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressSession({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 86,
    viewBox: "0 0 85 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3",
    d: "M2.40118 32.9971C0.791647 32.5812 -0.186222 30.9349 0.341143 29.3584C2.89002 21.7388 7.53087 14.9647 13.7602 9.82705C20.7657 4.04924 29.4204 0.637536 38.4841 0.0808985C47.5477 -0.475738 56.5549 1.85127 64.2147 6.72841C71.8745 11.6055 77.7937 18.7824 81.1239 27.2304C84.4541 35.6785 85.0244 44.9639 82.753 53.7559C80.4815 62.548 75.485 70.3952 68.4796 76.173C61.4742 81.9508 52.8194 85.3625 43.7558 85.9192C35.6963 86.4141 27.6814 84.629 20.6188 80.7983C19.1575 80.0057 18.7489 78.1349 19.6418 76.7326C20.5346 75.3304 22.3902 74.9294 23.8604 75.7053C29.8431 78.8626 36.5965 80.3275 43.3867 79.9105C51.1815 79.4318 58.6246 76.4977 64.6492 71.5288C70.6739 66.5599 74.9709 59.8113 76.9243 52.2501C78.8778 44.689 78.3873 36.7035 75.5234 29.4382C72.6594 22.1729 67.5689 16.0008 60.9814 11.8064C54.394 7.61209 46.6478 5.61087 38.8531 6.08958C31.0583 6.56829 23.6153 9.50235 17.5906 14.4713C12.3423 18.7998 8.40507 24.479 6.18611 30.8694C5.64082 32.4398 4.01071 33.4129 2.40118 32.9971Z",
    fill: "#0877BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressSession);
export default __webpack_public_path__ + "static/media/progressSession.dbd3de64ea648385de09f3bebac9342d.svg";
export { ForwardRef as ReactComponent };